// extracted by mini-css-extract-plugin
module.exports = {"root":"Totals_root__B0kOI","cardHeader":"Totals_cardHeader__3pwjp"};